<div class="toast-stack">
  <ngb-toast
    *ngFor="let toast of toastService.toasts"
    [class]="toast.classname"
    [header]="toast.header"
    [autohide]="toast.autohide"
    [delay]="toast.delay"
    (hidden)="toastService.remove(toast)"
  >
    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>
    <ng-template #text>{{ toast.textOrTpl }}</ng-template>
  </ngb-toast>
</div>